import { createContext, useContext, useEffect, useState } from 'react';

export const TokenContext = createContext();

// Function to retrieve a cookie by name
const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return null; // Explicitly return null if the cookie does not exist
};

export const TokenProvider = ({ children }) => {
  const [fallbackToken, setFallbackToken] = useState(null); // State to store the guest token

  // Get current path to decide token logic
  const currentPath = window.location.pathname;

  // Retrieve cookie token for main paths
  const cookieToken = getCookie('token');
  const isMainPath = currentPath === '/envibuddy/'; // Check if on the main `/envibuddy/` path
  const isGuestPath = currentPath.includes('/envibuddy/enviseer/') || currentPath.includes('/envibuddy/envistate/');

  useEffect(() => {
    if (isGuestPath||!cookieToken) {
      const url = 'https://infia.enviseer.com/api/api/token/default/generate';

      fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.text(); // Parse the response as text
        })
        .then((data) => {
          // Assuming the token is in the response data
          const updatedToken = data; // Adjust according to the actual response format
          setFallbackToken(updatedToken); // Store the token in state
          //console.log('Guest Token:', updatedToken); // Log the token
        })
        .catch((error) => {
          console.error('There was a problem with the fetch operation:', error);
        });
    }
  }, []);

  let companyName = 'envibuddy'; // Default company

  if (isMainPath) {
     if (cookieToken) {
      companyName = 'envibuddy'; // If main path and isGuestToken, set to 'spine'
    } else {
      companyName = 'spine'; // If main path and not guest, set to 'envibuddy'
    }
  } else if (isGuestPath) {
    if(currentPath.includes('/envibuddy/enviseer/')){
    companyName = 'enviseer';}
    else if(
    currentPath.includes('/envibuddy/envistate/')){
    companyName='envistate';}
  }

  // Use guest token or cookie token based on the path
  const token = isMainPath&&cookieToken ? cookieToken : fallbackToken;
  const isGuestToken = isGuestPath || !cookieToken;

  return (
    <TokenContext.Provider value={{ token, isGuestToken, companyName }}>
      {children}
    </TokenContext.Provider>
  );
};

// Hook to use the token
export const useToken = () => useContext(TokenContext);
